import { render, staticRenderFns } from "./InquiryCoupon.vue?vue&type=template&id=5c373fc0&"
import script from "./InquiryCoupon.vue?vue&type=script&lang=ts&"
export * from "./InquiryCoupon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports